<div class="channel-mixer" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
  <div class="channel-mixer-title">Channels</div>
  <div class="channel-strips">
    <div class="channel-strip" *ngFor="let strip of mixer?.strips" [class.muted]="strip.muted">
      <span class="channel-gain-value">{{ (strip.gain * 100) | number:'1.0-0' }}%</span>
      <div class="channel-strip-body">
        <div class="channel-meter" [matTooltip]="'Level ' + strip.level + '%'">
          <div class="channel-meter-fill" [style.height.%]="strip.level"></div>
        </div>
        <mat-slider vertical class="channel-gain-slider" color="primary"
          [min]="0" [max]="maxGainPercent" [step]="5" [value]="strip.gain * 100"
          (input)="setGain(strip.index, $event.value)"
          [attr.aria-label]="strip.label + ' volume'"></mat-slider>
      </div>
      <button type="button" class="channel-mute-btn" [class.muted]="strip.muted"
        (click)="toggleMute(strip.index)"
        [matTooltip]="strip.muted ? 'Unmute ' + strip.label : 'Mute ' + strip.label">
        <i class="material-icons">{{ strip.muted ? 'volume_off' : 'volume_up' }}</i>
      </button>
      <span class="channel-label">{{ strip.label }}</span>
    </div>
  </div>
</div>
